
import { Separator } from "@/components/ui/separator";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle, Lock } from "lucide-react";
import { CurrentDatabaseConfig } from './database/CurrentDatabaseConfig';
import { DatabaseConfigForm } from './database/DatabaseConfigForm';
import { DatabaseConfigList } from './database/DatabaseConfigList';
import { useSecureDatabaseConfig } from '@/hooks/useSecureDatabaseConfig';
import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export function DatabaseSettings() {
  const {
    configs,
    currentConfig,
    loading,
    saveConfig,
    switchToConfig,
    deleteConfig
  } = useSecureDatabaseConfig();

  const [newConfig, setNewConfig] = useState({
    name: "",
    type: "supabase" as const,
    host: "",
    port: 3306,
    database: "",
    username: "",
    password: "",
    url: "",
    anonKey: ""
  });

  const resetNewConfig = () => {
    setNewConfig({
      name: "",
      type: "supabase",
      host: "",
      port: 3306,
      database: "",
      username: "",
      password: "",
      url: "",
      anonKey: ""
    });
  };

  const handleConfigAdded = async (config: any) => {
    const configToSave = {
      name: config.name,
      type: config.type,
      config: config.config,
      is_active: false
    };
    
    await saveConfig(configToSave);
  };

  // Convert configs to old format for compatibility
  const legacyConfigs = configs.map(c => ({
    ...c,
    isActive: c.is_active
  }));

  // Convert currentConfig to old format
  const legacyCurrentConfig = currentConfig ? {
    ...currentConfig,
    isActive: currentConfig.is_active
  } : null;

  // Wrapper functions for compatibility
  const handleConfigSwitch = (config: any) => {
    switchToConfig(config.id);
  };

  const handleConfigDelete = (index: number) => {
    if (configs[index]) {
      deleteConfig(configs[index].id);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-muted-foreground">جاري تحميل الإعدادات...</div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Lock className="h-5 w-5" />
            إعدادات قاعدة البيانات الآمنة
          </CardTitle>
          <CardDescription>
            يتم الآن تخزين إعدادات قاعدة البيانات بشكل آمن في الخادم بدلاً من المتصفح
          </CardDescription>
        </CardHeader>
      </Card>

      <CurrentDatabaseConfig currentConfig={legacyCurrentConfig} />

      <Separator />

      <DatabaseConfigForm 
        newConfig={newConfig}
        setNewConfig={setNewConfig}
        onConfigAdded={handleConfigAdded}
        onResetForm={resetNewConfig}
      />

      <DatabaseConfigList 
        configs={legacyConfigs}
        onConfigSwitch={handleConfigSwitch}
        onConfigDelete={handleConfigDelete}
      />

      <Alert>
        <Lock className="h-4 w-4" />
        <AlertDescription>
          <strong>تحسين أمني:</strong> يتم الآن تشفير وحماية جميع بيانات الاتصال بقواعد البيانات في الخادم
        </AlertDescription>
      </Alert>
    </div>
  );
}
